/**
 * Check item exist in array
 *
 * @param {string} arrayItem - array item to check
 * @param {array} arr - array to check
 */
export function checkArrayItemExist(arrayItem, arr){
  for(var i = 0; i < arr.length; i++){
    if(arr[i] === arrayItem){
      return true;
    }
  }
}

/**
 * Check array match
 *
 * @param {array} arr1 - array one
 * @param {array} arr2 - array two
 */
export function arraysEqual(arr1, arr2) {
    if(arr1.length !== arr2.length)
        return false;
    for(var i = arr1.length; i--;) {
        if(arr1[i] !== arr2[i])
            return false;
    }
    return true;
}



// WEBPACK FOOTER //
// ./src/helpers/arrayUtils.js